import { API } from "../api/API";
import { validateResponseStatus } from "../utils";

export const postTracking = async (token, data) => {
  const result = await API()
    .post("academy/tracking/create", data)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return {
      ...result.data,
      success: true,
    };
  } else {
    return result.data;
  }
};

export const putTracking = async (token, data, id) => {
  const result = await API()
    .put(`academy/tracking/update/${id}`, data)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return {
      ...result.data,
      success: true,
    };
  } else {
    return result.data;
  }
};

export const getCompleted = async (courseId, contactId, token) => {
  const result = await API()
    .post(`academy/tracking/getCompleted`, { courseId, contactId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return {
      ...result.data[0],
      success: true,
    };
  } else {
    return result.data;
  }
};

export const getCompletedByUser = async (courseId, contactId, token) => {
  const result = await API()
    .post(`academy/tracking/getCompletedByUser`, { courseId, contactId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return result.data;
  }
};

// Todos los cursos con LECCIONES vistas por el usuario en UNA sola llamada.
// /tracking/getCompletedCoursesByUser devuelve [{ courseId, courseCode,
// courseName, completedAt }] ordenados por fecha desc. Sirve para el home
// (estado "logros") y para marcar cursos "completados" en el catálogo.
// NO implica examen aprobado — para eso, ver `getCertifiedCoursesByUser`.
export const getCompletedCoursesByUser = async (contactId, token) => {
  const result = await API()
    .post(`academy/tracking/getCompletedCoursesByUser`, { contactId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return Array.isArray(result.data) ? result.data : [];
  } else {
    return [];
  }
};

// Cursos con CERTIFICADO — el usuario aprobó su examen final. El backend
// hace JOIN con Examenes+Evaluaciones y filtra por
// Calificacion >= CalificacionMinima. Mismo shape que
// getCompletedCoursesByUser. Consumido por /logros: solo cursos con
// certificado descargable de verdad, no simplemente lecciones vistas.
export const getCertifiedCoursesByUser = async (contactId) => {
  const result = await API()
    .post(`academy/tracking/getCertifiedCoursesByUser`, { contactId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return Array.isArray(result.data) ? result.data : [];
  } else {
    return [];
  }
};
